<script setup lang="ts">
/**
 * Index page header row: count label on the left, action button on the right.
 * Used on tags index, item types index, etc.
 */
import { pluralize } from "@/lib/format"
import { ICON } from "@/lib/icons"

defineProps<{
  /** Number of items (used to build "N items" label) */
  count: number
  /** Singular noun (e.g. "tag", "type") — pluralized automatically */
  noun: string
  /** Irregular plural (e.g. "people" for "person") — overrides default "s" suffix */
  pluralNoun?: string
  /** Button label (e.g. "New Tag") */
  buttonLabel: string
  /** Button icon — defaults to ICON.add */
  buttonIcon?: string
}>()

const emit = defineEmits<{
  action: []
}>()
</script>

<template>
  <div class="flex items-center justify-between">
    <span class="text-muted text-xs">{{ pluralize(count, noun, pluralNoun) }}</span>
    <UButton
      :label="buttonLabel"
      :icon="buttonIcon ?? ICON.add"
      color="primary"
      size="sm"
      @click="emit('action')"
    />
  </div>
</template>
